import { useState } from 'react';

const faqData = [
  {
    question: '本当に即日でクレジットカードを発行できますか？',
    answer: 'はい、可能です。三井住友カード（NL）なら最短10秒でカード番号が発行され、すぐにネットショッピングやスマホ決済で利用できます。ただし、プラスチックカードの郵送には数日かかります。'
  },
  {
    question: '即日発行の審査は厳しいですか？',
    answer: '即日発行だからといって審査が特別厳しいわけではありません。通常のクレジットカードと同じ基準で審査されます。安定した収入があり、過去に金融事故がなければ、審査通過の可能性は十分にあります。'
  },
  {
    question: '土日祝日でも即日発行できますか？',
    answer: 'カード会社によって異なります。三井住友カード（NL）は土日祝日でも審査が行われるため、即日発行が可能です。ただし、審査状況によっては翌営業日以降になる場合もあります。'
  },
  {
    question: '学生でも即日発行できますか？',
    answer: 'はい、18歳以上の学生（高校生を除く）であれば申込み可能です。アルバイト収入がなくても、親権者の同意があれば審査に通る可能性があります。'
  },
  {
    question: '即日発行カードは年会費がかかりますか？',
    answer: '三井住友カード（NL）、大手ECモール系カード、リクルートカードなど、即日発行可能なカードの多くは年会費永年無料です。維持コストを気にせず利用できます。'
  },
  {
    question: '審査に落ちた場合、すぐに別のカードに申し込めますか？',
    answer: '短期間に複数のカードに申し込むと「申込みブラック」と判断され、審査に不利になる可能性があります。審査に落ちた場合は、最低でも6ヶ月程度の期間を空けてから次の申込みをすることをおすすめします。'
  },
  {
    question: 'カード番号だけ発行されて、プラスチックカードが届かないことはありますか？',
    answer: 'いいえ、カード番号が発行された後、必ずプラスチックカードも郵送されます。通常1週間程度で届きますが、住所不備などがある場合は遅れることがあります。'
  },
  {
    question: '即日発行カードの利用限度額はどのくらいですか？',
    answer: '審査結果によって異なりますが、初回は10万円〜50万円程度が一般的です。利用実績を積むことで、後から限度額を増額することも可能です。'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
          よくある質問（FAQ）
        </h2>
        <p className="text-center text-gray-600 mb-12">
          即日発行に関する疑問を解決します
        </p>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-teal-300 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-teal-600 font-bold">Q</span>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">{faq.question}</h3>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 pl-18">
                  <div className="flex items-start gap-4 bg-teal-50 rounded-lg p-4">
                    <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold">A</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
